// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application";

import HelloController from "./hello_controller";
application.register("hello", HelloController);

import JobTriggerController from "./job_trigger_controller";
application.register("job-trigger", JobTriggerController);

import PasswordStrengthController from "./password_strength_controller";
application.register("password-strength", PasswordStrengthController);

import SidebarController from "./sidebar_controller";
application.register("sidebar", SidebarController);

import DropdownController from "./dropdown_controller";
application.register("dropdown", DropdownController);

import SidebarMenuController from "./sidebar_menu_controller";
application.register("sidebar-menu", SidebarMenuController);

import TogglePasswordVisibilityController from "./toggle_password_visibility";
application.register(
  "toggle-password-visibility",
  TogglePasswordVisibilityController,
);

import CollapsibleController from "./collapsible_controller";
application.register("collapsible", CollapsibleController);

import VideoSelectionController from "./video_selection_controller";
application.register("video-selection", VideoSelectionController);

import ModalController from "./modal_controller";
application.register("modal", ModalController);

import SearchAutocompleteController from "./search_autocomplete_controller";
application.register("search-autocomplete", SearchAutocompleteController);

import ReachChartController from "./reach_chart_controller";
application.register("reach-chart", ReachChartController);

import BillingToggleController from "./billing_toggle_controller";
application.register("billing-toggle", BillingToggleController);

import SortableController from "./sortable_controller";
application.register("sortable", SortableController);

import CountdownController from "./countdown_controller";
application.register("countdown", CountdownController);

import EditCancelController from "./edit_cancel_controller";
application.register("edit-cancel", EditCancelController);

import VideoDrawerController from "./video_drawer_controller";
application.register("video-drawer", VideoDrawerController);

import VideoLayoutController from "./video_layout_controller";
application.register("video-layout", VideoLayoutController);

import DashboardChartController from "./dashboard_chart_controller";
application.register("dashboard-chart", DashboardChartController);

import DashboardFilterController from "./dashboard_filter_controller";
application.register("dashboard-filter", DashboardFilterController);

import SearchResultsController from "./search_results_controller";
application.register("search-results", SearchResultsController);

import ChannelDonutController from "./channel_donut_controller";
application.register("channel-donut", ChannelDonutController);

import DatePickerController from "./date_picker_controller";
application.register("date-picker", DatePickerController);

import DirtyFormController from "./dirty_form_controller";
application.register("dirty-form", DirtyFormController);

import ProgressWizardController from "./progress_wizard_controller";
application.register("progress-wizard", ProgressWizardController);

import ReplyComposerController from "./reply_composer_controller";
application.register("reply-composer", ReplyComposerController);
